import { render, staticRenderFns } from "./CustomsInfo.vue?vue&type=template&id=47dccd1e&scoped=true"
import script from "./CustomsInfo.vue?vue&type=script&lang=js"
export * from "./CustomsInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomsInfo.vue?vue&type=style&index=0&id=47dccd1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dccd1e",
  null
  
)

export default component.exports